<template>
  <div class="import-all-products">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :header="`${equipament.model_code} | Importar Produtos Disponíveis`"
      :visible="show"
      :modal="true"
      :closable="false"
      :maximizable="true"
      :style="{ width: '50vw' }"
      @hide="cancel()"
    >
      <Loading :active.sync="loading" :isFullPage="false"></Loading>
      <div class="p-mb-2 p-d-flex p-jc-between actions-menu-import-all-products">
        <div>
          <SelectButton
            v-model="treeBy"
            :options="treeByOptions"
            optionLabel="label"
            optionValue="value"
            @input="onTreeByChange"
          />
        </div>
        <div>
          <div>
            <Button
              type="button"
              icon="pi pi-check-square"
              label="Selecionar Tudo"
              class="p-mr-1"
              @click="selectAll"
            />
            <Button
              type="button"
              icon="pi pi-stop"
              label="Desmarcar Tudo"
              class="p-mr-1"
              @click="deselectAll"
            />
          </div>
          <div class="p-mt-2">
            <Button
              type="button"
              icon="pi pi-plus"
              label="Abrir Tudo"
              class="p-mr-1"
              @click="expandAll"
            />
            <Button
              type="button"
              icon="pi pi-minus"
              label="Fechar Tudo"
              @click="collapseAll"
            />
          </div>
        </div>
      </div>
      <Tree
        selectionMode="checkbox"
        :value="treeNodes"
        :selectionKeys.sync="selectedNodes"
        :expandedKeys="expandedKeys"
        @node-select="onNodeSelect"
        @node-unselect="onNodeUnselect"
      />
      <template #footer>
        <Button
          label="Fechar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
        <Button
          label="Guardar"
          class="p-button-success"
          icon="pi pi-save"
          @click="submit"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import sparsService from "../../services/spars.service";
import Loading from "vue-loading-overlay";
export default {
  name: "ImportProducts",
  props: ["show", "equipament"],
  components: {
    Loading,
  },
  watch: {
    show: {
      immediate: true,
      async handler(show) {
        if (show === true) {
          this.loading = true;
          this.restoreTreeBy();
          await this.initTreeData();
          this.loading = false;
        }
      },
    },
  },
  data() {
    return {
      loading: false,
      parts: [],
      treeNodes: [],
      selectedNodes: {},
      expandedKeys: {},
      defaultFamilyIds: [],
      familyDefaultsChanged: false,
      treeBy: "location",
      treeByStorageKey: "importProducts.treeBy",
      treeByOptions: [
        { label: "Por Localização", value: "location" },
        { label: "Por Familia", value: "family" },
      ],
    };
  },
  deactivated() {
    this.cancel();
    document.body.classList.remove('p-overflow-hidden');
  },
  beforeDestroy() {
    document.body.classList.remove('p-overflow-hidden');
  },
  methods: {
    restoreTreeBy() {
      try {
        const saved = localStorage.getItem(this.treeByStorageKey);
        const isValid = this.treeByOptions.some((o) => o.value === saved);
        if (isValid) {
          this.treeBy = saved;
        }
      } catch (e) {
        // localStorage unavailable, keep default treeBy
      }
    },
    persistTreeBy() {
      try {
        localStorage.setItem(this.treeByStorageKey, this.treeBy);
      } catch (e) {
        // localStorage unavailable, ignore
      }
    },
    async onTreeByChange() {
      this.persistTreeBy();
      await this.initTreeData();
    },
    async getData() {
      this.loading = true;
      try {
        this.parts = await sparsService.getEquipamentsPartsFomApi(
          this.equipament.id
        );

        let uniqueFamilies = {};
        this.parts.forEach((part) => {
          const id = part.family_id;
          if (!uniqueFamilies[id]) {
            uniqueFamilies[id] = part.family;
          }
        });
      } catch (error) {

        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.message || "Erro ao buscar produtos",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    getGroupedUniqueValues(keyForUniqueness, keyForValue) {
      const uniqueItems = {};

      this.parts.forEach((part) => {
        const id = part[keyForUniqueness];

        if (id !== undefined && !(Object.prototype.hasOwnProperty.call(uniqueItems, id))) {
          uniqueItems[id] = part[keyForValue];
        }
      });

      return Object.values(uniqueItems);
    },
    async initTreeData() {
      await this.getData();
      this.treeNodes = [];
      this.selectedNodes = {};
      this.defaultFamilyIds = [...new Set(
        this.parts
          .filter(part => part.family && (part.family.is_default == 1 || part.family.is_default === true))
          .map(part => part.family_id)
      )];
      this.familyDefaultsChanged = false;
      if (this.treeBy === "location") {
        return this.initTreeModelData({
          groupByKey: 'location_no',
          getGroupLabel: (part) => part.location_no,
          getNodeLabel: (part) => part.reference + " - " + part.long_description
        });
      }
      return this.initTreeModelData({
        groupByKey: 'family_id',
        getGroupLabel: (part) =>
          part.family && part.family.name ? part.family.name : "Sem Família",
        getNodeLabel: (part) => part.reference + " - " + part.long_description
      });
    },
    async initTreeModelData({ groupByKey, getGroupLabel, getNodeLabel }) {
      this.loading = true;
      this.treeNodes = [];
      this.selectedNodes = {};

      const uniqueGroupIds = [...new Set(this.parts.map(part => part[groupByKey]))];

      uniqueGroupIds.forEach(groupId => {
        if (groupId === null || groupId === undefined) return;

        const firstPartInGroup = this.parts.find(p => p[groupByKey] === groupId);
        if (!firstPartInGroup) return;

        let groupLabel;
        try {
          groupLabel = getGroupLabel(firstPartInGroup);
        } catch (e) {
          groupLabel = String(groupId);
        }

        const groupNode = {
          key: groupId.toString(),
          id: groupId,
          label: groupLabel,
          data: "grouped",
          children: [],
        };

        let checkedItems = 0;
        const partsInGroup = this.parts.filter(p => p[groupByKey] === groupId);

        partsInGroup.forEach(part => {
          const partKey = `${groupId}-${part.reference}`;
          const partNode = {
            key: partKey,
            id: part.id,
            reference: part.reference,
            part: part,
            label: getNodeLabel(part),
            data: "node",
          };

          groupNode.children.push(partNode);

          const isLinkedToEquipment = part.equipments && part.equipments.some(e => e.id === this.equipament.id);
          const isFamilyDefault = part.family && (part.family.is_default == 1 || part.family.is_default === true);

          if (isLinkedToEquipment || isFamilyDefault) {
            checkedItems++;
            this.selectedNodes[partNode.key] = {
              checked: true,
              partialChecked: false,
            };
          }
        });

        this.treeNodes.push(groupNode);

        if (checkedItems > 0) {
          this.selectedNodes[groupNode.key] = {
            checked: checkedItems === groupNode.children.length,
            partialChecked: checkedItems < groupNode.children.length,
          };
        }
      });

      this.loading = false;
    },
    onNodeSelect(node) {
      if (this.treeBy !== "family" || node.data !== "grouped") return;

      if (!this.defaultFamilyIds.includes(node.id)) {
        this.defaultFamilyIds.push(node.id);
      }
      this.familyDefaultsChanged = true;
    },
    onNodeUnselect(node) {
      if (this.treeBy !== "family" || node.data !== "grouped") return;

      this.defaultFamilyIds = this.defaultFamilyIds.filter(id => id !== node.id);
      this.familyDefaultsChanged = true;
    },
    async submit() {
      const selectedParts = [];

      Object.keys(this.selectedNodes).forEach(key => {
        if (this.selectedNodes[key].checked) {
          const node = this.findNodeByKey(key);
          if (node && node.data === "node" && node.part) {
            selectedParts.push(node.part);
          }
        }
      });

      if (selectedParts.length === 0 && !this.familyDefaultsChanged) {
        this.$toast.add({
          severity: "warn",
          summary: "Aviso",
          detail: "Nenhum produto selecionado para sincronizar",
          life: 3000,
        });
        return;
      }

      this.loading = true;

      try {
        const payload = {
          parts: selectedParts,
        };
        if (this.familyDefaultsChanged) {
          payload.family_ids = [...new Set(
            this.parts
              .map(part => part.family_id)
              .filter(id => id !== null && id !== undefined)
          )];
          payload.family_defaults = this.defaultFamilyIds;
        }

        const response = await sparsService.syncRelationEquipmentProducts(
          this.equipament.id,
          payload
        );

        if (response) {
          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: `${selectedParts.length} produto(s) adicionado(s) ao equipamento. Sincronização em andamento...`,
            life: 4000,
          });

          this.cancel();
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Erro ao sincronizar produtos",
            life: 3000,
          });
        }
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.message || "Erro ao sincronizar produtos",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    findNodeByKey(key) {
      for (let groupNode of this.treeNodes) {
        if (groupNode.key === key) {
          return groupNode;
        }
        if (groupNode.children) {
          for (let childNode of groupNode.children) {
            if (childNode.key === key) {
              return childNode;
            }
          }
        }
      }
      return null;
    },
    cancel() {
      this.loading = false;
      this.parts = [];
      this.treeNodes = [];
      this.selectedNodes = {};
      this.defaultFamilyIds = [];
      this.familyDefaultsChanged = false;
      return this.$emit("cancel");
    },
    selectAll() {
      this.selectedNodes = {};

      this.treeNodes.forEach(groupNode => {

        this.selectedNodes[groupNode.key] = {
          checked: true,
          partialChecked: false,
        };

        if (groupNode.children && groupNode.children.length > 0) {
          groupNode.children.forEach(childNode => {
            this.selectedNodes[childNode.key] = {
              checked: true,
              partialChecked: false,
            };
          });
        }
      });

      this.selectedNodes = { ...this.selectedNodes };

      this.$toast.add({
        severity: "info",
        summary: "Informação",
        detail: "Todos os produtos foram selecionados",
        life: 2000,
      });
    },
    deselectAll() {
      this.selectedNodes = {};

      this.$toast.add({
        severity: "info",
        summary: "Informação",
        detail: "Todos os produtos foram desmarcados",
        life: 2000,
      });
    },
    expandAll() {
      for (let node of this.treeNodes) {
        this.expandNode(node);
      }

      this.expandedKeys = { ...this.expandedKeys };
    },
    collapseAll() {
      this.expandedKeys = {};
    },
    expandNode(node) {
      if (node.children && node.children.length) {
        this.expandedKeys[node.key] = true;

        for (let child of node.children) {
          this.expandNode(child);
        }
      }
    },
  },
};
</script>
<style>
.import-all-products {
  position: relative;
  min-height: 40%;
}
.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
  background: #fff;
  color: #000;
}
.p-tree-container .pi-chevron-right:before {
  color: #6c757d;
}
.p-tree-container .pi-chevron-down:before {
  color: #6c757d;
}
.actions-menu-import-all-products {
  margin: auto;
  align-items: end;
}
</style>
